import React, { useState } from "react";
import { Link } from "react-router-dom";
import arrowIcon from "../../images/menuListIcons/arrow-icon.svg";

const DesctopMenuItem = ({ menuItem, location, showSubMenuItems, toggleSubmenuItemHandler }) => {
    if (menuItem.links.length < 1) {
        return (
            <div
                className={
                    menuItem.link === location.pathname
                        ? "desctop-menu__list-item-active desctop-menu__list-item"
                        : "desctop-menu__list-item"
                }
                onClick={() => toggleSubmenuItemHandler(menuItem.id, menuItem.link, menuItem.name)}
                to={menuItem.link}
            >
                <div className="desctop-menu__list-item-icon">
                    <menuItem.img fill={menuItem.link === location.pathname ? "#EE3124" : "#414042"} />
                </div>
                <div className="desctop-menu__list-item-title">{menuItem.name}</div>
            </div>
        );
    }

    return (
        <>
            <div
                className={
                    menuItem.links.some((linkItem) => linkItem.link === location.pathname)
                        ? "desctop-menu__list-item-active desctop-menu__list-item"
                        : "desctop-menu__list-item"
                }
                onClick={() => toggleSubmenuItemHandler(menuItem.id)}
            >
                <div className="desctop-menu__list-item-icon">
                    <menuItem.img
                        fill={
                            menuItem.links.some((linkItem) => linkItem.link === location.pathname)
                                ? "#EE3124"
                                : "#414042"
                        }
                    />
                </div>
                <div className="desctop-menu__list-item-title">{menuItem.name}</div>
                <img src={arrowIcon} alt="arrow" className="desctop-menu__list-item-arrow" />
            </div>
            {showSubMenuItems === menuItem.id &&
                menuItem.links.map((link) => {
                    return (
                        <Link
                            key={link.link}
                            className={
                                link.link === location.pathname
                                    ? "desctop-menu__list-sub-item-active desctop-menu__list-sub-item"
                                    : "desctop-menu__list-sub-item"
                            }
                            to={link.link}
                        >
                            <div className="desctop-menu__list-sub-item-title">{link.name}</div>
                        </Link>
                    );
                })}
        </>
    );
};

export default DesctopMenuItem;
